export default __webpack_public_path__ + "static/media/portfoliovignitus.70427f4f.png";